var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 2.33337C6.66117 2.33337 2.33325 6.66129 2.33325 12C2.33325 17.3388 6.66117 21.6667 11.9999 21.6667C17.3387 21.6667 21.6666 17.3388 21.6666 12C21.6666 6.66129 17.3387 2.33337 11.9999 2.33337ZM0.333252 12C0.333252 5.55672 5.5566 0.333374 11.9999 0.333374C18.4432 0.333374 23.6666 5.55672 23.6666 12C23.6666 18.4434 18.4432 23.6667 11.9999 23.6667C5.5566 23.6667 0.333252 18.4434 0.333252 12ZM11.9999 5.66671C12.5522 5.66671 12.9999 6.11442 12.9999 6.66671V11H17.3333C17.8855 11 18.3333 11.4478 18.3333 12C18.3333 12.5523 17.8855 13 17.3333 13H12.9999V17.3334C12.9999 17.8857 12.5522 18.3334 11.9999 18.3334C11.4476 18.3334 10.9999 17.8857 10.9999 17.3334V13H6.66659C6.1143 13 5.66659 12.5523 5.66659 12C5.66659 11.4478 6.1143 11 6.66659 11H10.9999V6.66671C10.9999 6.11442 11.4476 5.66671 11.9999 5.66671Z",
    fill: "#FFFF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsAddIcon);
export default __webpack_public_path__ + "static/media/newsAddIcon.86e6529d.svg";
export { ForwardRef as ReactComponent };